module.exports = __webpack_public_path__ + "static/hero-img-mobile@2x-d85acf12e5ddf11c4cb518cf6d817ea9.png";